import React from 'react';
import { Ambient } from '../Ambient';
import { PartnerMark, VexuLockup } from '../Brand';
import { Eyebrow, Hairline, Reveal } from '../Reveal';
import { usePartner } from '../../../contexts/PartnerContext';
const OPPORTUNITIES = [{
  title: 'New AI Revenue Streams',
  body: 'Launch premium AI-powered services for consumer and business subscribers.'
}, {
  title: 'Leverage Existing Telecom Assets',
  body: 'Transform phone numbers, voice connectivity, distribution channels, and subscriber relationships into AI-enabled services.'
}, {
  title: 'Faster Time to Market',
  body: 'Deploy proven AI products without having to build the entire conversational AI technology stack internally.'
}, {
  title: 'Multiple Verticals. One Partnership.',
  body: 'Consumer AI, business communications, and conversational commerce — powered by one underlying technology platform.'
}];
export function PartnershipSlide() {
  const partner = usePartner();
  return <section className="relative h-full w-full" data-id="element-635" data-mp="42lwigo73rd8">
      <Ambient variant="default" data-id="element-636" data-mp="41asqgur2jm4" />

      <div className="relative flex h-full gap-[70px] px-[100px] pb-[70px] pt-[76px]" data-id="element-637" data-mp="3v8f23iedahxp">
        {/* Narrative */}
        <div className="flex w-[520px] flex-col" data-id="element-638" data-mp="3qh59c8xiuyhl">
          <Reveal delay={0} data-id="element-639" data-mp="3qfu9ulb40cwa">
            <Eyebrow data-id="element-640" data-mp="3liln07f0nkop">{`Why Vexu × ${partner.name}`}</Eyebrow>
          </Reveal>

          <Reveal delay={0.08} y={18} data-id="element-641" data-mp="3lghipod7gjnw">
            <div className="mt-[26px] flex items-center gap-[24px]" data-id="element-642" data-mp="3gk0oqdjbrb2w">
              <VexuLockup size={38} wordmarkSize={30} data-id="element-643" data-mp="3chx8lblpniba" />
              <span className="text-[26px] text-slate-300" data-id="element-644" data-mp="3ch4cd4kdob7e">×</span>
              <PartnerMark height={34} data-id="element-645" data-mp="37iawj5hmc842" />
            </div>
          </Reveal>

          <Reveal delay={0.16} data-id="element-646" data-mp="32jpv52qmrie1">
            <h2 className="mt-[30px] text-[38px] font-light leading-[1.24] tracking-[-0.025em] text-slate-500" data-id="element-647" data-mp="32kj6kh0jaw2i">
              Turning Telecom Infrastructure &amp; Reach into{' '}
              <span className="font-medium text-slate-900" data-id="element-648" data-mp="10smlafoke7uj">
                AI-Powered Services
              </span>
            </h2>
          </Reveal>

          <div className="flex-1" data-id="element-649" data-mp="2v7a4rp0419zy" />

          <Reveal delay={0.5} data-id="element-650" data-mp="2zzbfv7ljkuoe">
            <Hairline data-id="element-651" data-mp="300d0o3sd0vjb" />
            <p className="pt-[28px] text-[19px] font-light leading-[1.6] tracking-[-0.01em] text-slate-500" data-id="element-652" data-mp="300ut0pbwiply">
              {partner.name} brings the network, reach and customer
              relationship. Vexu brings the AI technology.
              <br data-id="element-653" data-mp="3dz2xdib9ot75" />
              <span className="font-medium text-slate-900" data-id="element-654" data-mp="3dyjhs893agwa">
                Together, we can create the next generation of telecom services.
              </span>
            </p>
          </Reveal>

          <Reveal delay={0.58} data-id="element-655" data-mp="341eq5swh5t83">
            <div className="mt-[30px] flex items-center gap-[18px]" data-id="element-656" data-mp="3403njwermrik">
              <PartnerMark height={22} data-id="element-657" data-mp="38zgi73bvp2vp" />
              <span className="text-[15px] text-slate-300" data-id="element-658" data-mp="38y55ge0ggksg">+</span>
              <VexuLockup size={24} wordmarkSize={16} data-id="element-659" data-mp="1slgl004f3rc5" />
              <span className="text-[15px] text-vexu-600" data-id="element-660" data-mp="1so2sy0v808uw">→</span>
              <span className="text-[13px] font-semibold uppercase tracking-[0.2em] text-vexu-600" data-id="element-661" data-mp="1xme5ijcwgxgt">
                Next Generation AI Services
              </span>
            </div>
          </Reveal>
        </div>

        {/* Opportunities */}
        <div className="grid flex-1 grid-cols-2 grid-rows-2 gap-x-[52px] gap-y-[46px] pt-[10px]" data-id="element-662" data-mp="onw36yrp4yjk">
          {OPPORTUNITIES.map((item, index) => <Reveal key={item.title} delay={0.22 + index * 0.07} data-id="element-663" data-mp="knlzxtvagm8e" data-mpi={index}>
              <div className="flex h-full flex-col border-t border-slate-900/[0.10] pt-[22px]" data-id="element-664" data-mp="3t1kwoxq34bmy">
                <span className="text-[11px] font-semibold tabular-nums tracking-[0.28em] text-vexu-600" data-id="element-665" data-mp="3o3jcuaku48af">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-[14px] text-[23px] font-medium leading-[1.24] tracking-[-0.02em] text-slate-900" data-id="element-666" data-mp="ybiobfw9t86">
                  {item.title}
                </h3>
                <p className="mt-[12px] text-[14.5px] font-light leading-[1.7] text-slate-500" data-id="element-667" data-mp="39caixp9wg0rh">
                  {item.body}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}